import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnalysisComponent } from './components/analysis.component';
import { ResourceTypeComponent } from './components/resource-type/resource-type.component';
import { ResourceComponent } from './components/resource/resource.component';
import { EventTypeComponent } from './components/event-type/event-type.component';
import { ResourceEventComponent } from './components/resource-event/resource-event.component';
import { StatComponent } from './components/stat/stat.component';
const routes: Routes = [
  {
    path: '',
    component: AnalysisComponent,
    children: [
      {
        path: 'resource-type',
        component: ResourceTypeComponent,
      },
      {
        path: 'resource',
        component: ResourceComponent,
      },
      {
        path: 'event-type',
        component: EventTypeComponent,
      },
      {
        path: 'resource-event',
        component: ResourceEventComponent,
      },
      {
        path: 'stat',
        component: StatComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AnalysisRoutingModule {}
